import { Theme } from '@mui/material'

export interface IColorOption {
  label: string
  value: string
}

export const getBackgroundColors = (theme: Theme): IColorOption[] => [
  { label: 'White', value: theme.palette.common.white },
  { label: 'Light Gray', value: theme.palette.grey[300] },
  { label: 'Gray', value: theme.palette.grey[500] },
  { label: 'Secondary', value: theme.palette.secondary.main },
  { label: 'Dark Gray', value: theme.palette.grey[800] },
  { label: 'Navy', value: theme.palette.primaryDark.main },
  { label: 'Primary', value: theme.palette.primary.main },
  { label: 'Error', value: theme.palette.error.main },
  { label: 'Black', value: theme.palette.common.black },
]
